import React from "react";

import GoogleAuthButton from "../GoogleAuthButton";

const GoogleSignupButton = () => (
    <GoogleAuthButton buttonAttrs={{ "data-text": "signup_with" }} />
);

export default GoogleSignupButton;
